export default function initHorizontalMobile(selectorOrEl = '.SearhTag__list') {
    const scrollContainer =
        typeof selectorOrEl === 'string'
            ? document.querySelector(selectorOrEl)
            : selectorOrEl;

    // Se non c'è l'elemento, non fare nulla (evita errori)
    if (!scrollContainer) return;

    // Evita di attaccare listener più volte (se init viene richiamata)
    if (scrollContainer.dataset.dragScrollInit === '1') return;
    scrollContainer.dataset.dragScrollInit = '1';

    // --- Desktop drag ---
    scrollContainer.addEventListener('mousedown', (e) => {
        e.preventDefault();

        let isDragging = true;
        const startX = e.pageX - scrollContainer.offsetLeft;
        const startScrollLeft = scrollContainer.scrollLeft;

        const onMouseMove = (ev) => {
            if (!isDragging) return;
            const x = ev.pageX - scrollContainer.offsetLeft;
            const walk = (x - startX) * 1;
            scrollContainer.scrollLeft = startScrollLeft - walk;
        };

        const onMouseUp = () => {
            isDragging = false;
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    });

    // --- Mobile touch drag ---
    scrollContainer.addEventListener('touchstart', (e) => {
        const startX = e.touches[0].pageX - scrollContainer.offsetLeft;
        const startScrollLeft = scrollContainer.scrollLeft;

        const onTouchMove = (ev) => {
            const x = ev.touches[0].pageX - scrollContainer.offsetLeft;
            const walk = (x - startX) * 1;
            scrollContainer.scrollLeft = startScrollLeft - walk;
        };

        const onTouchEnd = () => {
            scrollContainer.removeEventListener('touchmove', onTouchMove);
            scrollContainer.removeEventListener('touchend', onTouchEnd);
        };

        scrollContainer.addEventListener('touchmove', onTouchMove, { passive: true });
        scrollContainer.addEventListener('touchend', onTouchEnd);
    }, { passive: true });
}